<template>
    <div id="asset-loader">
        <div class="text">TÜRKİYE’NİN Suyunu BİRLİKTE KORUYABİLİRİZ</div>
        <div class="la-loading">
            <svg width="82" height="82">
                <circle cx="41" cy="41" r="40" fill="none" stroke="white" stroke-width="3px" stroke-dasharray="0"
                        stroke-dashoffset="360"/>
            </svg>
            <img :src="require('@/assets/img/icons/white-drop.svg')"/>
            <p>{{ '%' + total }}</p>
        </div>
    </div>
</template>

<script>
    import EventBus from "../main";

    export default {
        name: "Loading",
        data() {
            return {
                total: 0,
                timeOutInterval: null
            }
        },
        watch: {
            total(value) {
                if (value >= 100) {
                    this.total = 100;
                    localStorage.setItem('previous', JSON.stringify({d : (new Date().getTime() + (1000 * 60 * 60 * 24 * 7))}));
                    this.$router.push({name: 'Home'});
                }
            }
        },
        methods: {
            timeOut() {
                this.timeOutInterval = setInterval(() => {
                    if (this.total % 8 === 0) {
                        this.total += Math.floor(Math.random() * (8 - 1)) + 1;
                    } else {
                        this.total++;
                    }
                }, 273);
            }
        },
        beforeDestroy() {
            clearInterval(this.timeOutInterval);
            EventBus.$emit('story-background', 'hide-dune-video');
        },
        mounted() {
            this.timeOut();
            EventBus.$emit('menu-status', false);
            this.$store.commit('navigationStatus', 'subPage');
            EventBus.$emit('story-background', 'show-dune-video');
        }
    }
</script>

<style lang="scss">
    #asset-loader {
        width: 100%;
        height: 100%;
        z-index: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .text {
            text-shadow: 0 1px 1px rgba(0, 0, 0, 0.22);
            font-family: "Quicksand", sans-serif, Tahoma;
            font-size: 23px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            text-transform: uppercase;
        }

        .la-loading {
            position: relative;
            width: 85px;
            height: 85px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            margin: 25px auto 300px auto;

            svg {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
            }

            p {
                margin: 5px;
                font-family: "Quicksand", sans-serif, Tahoma;
                font-size: 13px;
                font-weight: bold;
            }
        }

        #la-loaded-elements {
            display: none;
        }
    }
</style>